import { atom, selector } from 'recoil';

import { hasDmsListCapabilitySelector } from '@asa/asasqt-microfrontend-components/dist/common/guards/dmsGuard/core/recoil';
import { persistAtomOnLocalStorage } from '@asa/asasqt-microfrontend-components/dist/common/state/recoilPersist';

import { appointmentFilterAtomDefault } from '../utils/consts';
import {
  AppointmentDateFilterData,
  DmsSearchByParamsWithDefault,
  DmsSearchByValues,
} from '../utils/types';

export const dashboardSearchValueAtom = atom<string>({
  key: 'dashboardSearchValue',
  default: '',
});

export const searchForVehiclesAtom = atom<boolean>({
  key: 'searchForVehicles',
  default: false,
});

export const shouldDisplaySearchesAtom = atom<boolean>({
  key: 'shouldDisplaySearches',
  default: false,
});

export const accountSettingsLoadingAtom = atom<boolean>({
  key: 'accountSettingsLoading',
  default: true,
});

export const dmsSearchByParamsWithDefaultAtom =
  atom<DmsSearchByParamsWithDefault | null>({
    key: 'dmsSearchByParams',
    default: {
      defaultSelectedOnDropdown: DmsSearchByValues.CustomerName,
    },
    effects_UNSTABLE: [persistAtomOnLocalStorage],
  });

export const isDmsSwitchOnAtom = atom<boolean>({
  key: 'isDmsSwitchOn',
  default: false,
  effects_UNSTABLE: [persistAtomOnLocalStorage],
});

export const appointmentDateFilterDataAtom =
  atom<AppointmentDateFilterData | null>({
    key: 'appointmentDateFilter',
    default: appointmentFilterAtomDefault,
  });

export const isDmsActiveSelector = selector({
  key: 'isDmsActive',
  get: ({ get }) => {
    const isDmsSwitchOn = get(isDmsSwitchOnAtom);
    const hasDmsListCapability = get(hasDmsListCapabilitySelector);

    return hasDmsListCapability && isDmsSwitchOn;
  },
});
